import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, FullPageWrapper } from 'shared/ui'
import { LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES } from 'shared/constants/links'
import { ContactsDetails } from 'widgets/ContactsDetails'
import {
  BroadcastContactStatistics,
  BroadcastDetailHeader,
} from 'pages/broadcasts/ui/BroadcastDetail'
import { BroadcastContactStatisticsTable } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/ui/BroadcastContactStatisticsTable/BroadcastContactStatisticsTable'
import { BroadcastContactStatisticsSearch } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/ui/BroadcastContactStatisticsSearch/BroadcastContactStatisticsSearch'
import { useBroadcastDetailOneTimeContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime/context/context'

export const Content = observer(() => {
  const store = useBroadcastDetailOneTimeContext()

  useEffect(() => {
    store.init()

    return () => {
      store.reset()
    }
  }, [])

  return (
    <FullPageWrapper>
      <BroadcastDetailHeader store={store} />
      {store.type === 'ringless' && (
        <div style={{ margin: '0 20px 16px 20px' }}>
          <Alert
            item={{
              type: 'infoLight',
              title: 'Ringless voicemails typically reach 60–85% of contacts',
            }}
            rightActions={[
              {
                variant: 'link',
                type: 'primary',
                text: 'Learn why delivery varies',
                link: LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES,
              },
            ]}
          />
        </div>
      )}
      <BroadcastContactStatistics
        filters={store.filters}
        onActiveFilter={store.onActiveFilter}
        filter={store.filter}
      />
      <BroadcastContactStatisticsSearch />
      <BroadcastContactStatisticsTable />
      {store.contactsDetailsStore && <ContactsDetails store={store.contactsDetailsStore} />}
    </FullPageWrapper>
  )
})
